module.exports = __webpack_public_path__ + "static/specialists-slideshow-05-46bbc55e13dcec3633d1d018814aa352.jpg";